export const URL = process.env.LJR_API_URL || 'http://localhost:8000/api/';
// export const URL = 'http://ec2-54-233-223-10.sa-east-1.compute.amazonaws.com:8000/api/'
export const TOKKO_SERVICE_KEY = '6ece265ac56d3ea2f96b8352a38889ff656382b2'
export const TOKKO_SERVICE_URL = process.env.LJR_TOKKO_SERVICE_URL || 'https://www.tokkobroker.com/api/v1/'
export const DIST_URL = process.env.DIST_URL || ''
export const PROPERTIES = '/propiedades'
export const HOME = '/'
export const RESIDENTIAL = '/residencial'
export const PUERTOS = '/puertos'
export const OFFICES = '/oficinas'
export const LOCAL = '/locales'
export const INDUSTRIES = '/industrias'
export const HOTELS = '/hoteles'
export const FIELDS = '/campos'
export const EMPRENDIMIENTOS = '/emprendimientos'
export const TERRAINS = '/terrenos'
export const ENTREPENEURSHIP  = '/emprendimientos'
export const NEIGHBORHOODS = '/barrios'
export const EDIFICIOS = '/edificios'
export const PROPERTIES_HOME = '/properties_home'



// WEBPACK FOOTER //
// ./src/constants/api.js